import React from 'react';

const AccessDenied = () => {
  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <div style={styles.error}>403</div>
        <h1 style={styles.title}>Forbidden</h1>
        <p style={styles.message}>Sorry, you are not allowed to access this page.</p>
      </div>
    </div>
  );
};

const styles = {
  body: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    color: '#333',
    textAlign: 'center',
    margin: 0,
    padding: 0,
  },
  container: {
    maxWidth: '600px',
    margin: '0 auto',
    padding: '20px',
    backgroundColor: 'white',
    marginTop: '10%',
  },
  error: {
    fontSize: '62px',
    fontWeight: 'bold',
    color: '#e74c3c',
  },
  title: {
    fontSize: '42px',
    color: '#e74c3c',
  },
  message: {
    fontSize: '25px',
    color: '#333',
  },
  footer: {
    fontSize: '14px',
    color: '#888',
    marginTop: '30px',
  },
};

export default AccessDenied;
